import styled from '@emotion/styled';

export const Root = styled.p`
  color: inherit;
`;
